import React, { useState, useEffect, Fragment } from 'react';
import PerfectScrollbar from 'react-perfect-scrollbar';
import {
    Box, Card, Grid, TextField, makeStyles, Container, Button,
    CardContent, MenuItem, Divider, InputLabel, CardHeader, Switch, Checkbox, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography, Chip
} from '@material-ui/core';
import Page from 'src/components/Page';
import services from '../Services';
import { useNavigate } from 'react-router-dom';
import { Formik } from 'formik';
import * as Yup from "yup";
import { useAlert } from "react-alert";
import { LoadingComponent } from '../../../utils/newLoader';
import { trackPromise } from 'react-promise-tracker';
import authService from '../../../utils/permissionAuth';
import tokenService from '../../../utils/tokenDecoder';
import tokenDecoder from '../../../utils/tokenDecoder';
import { KeyboardDatePicker } from "@material-ui/pickers";
import { MuiPickersUtilsProvider } from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';
import { AlertDialog } from '../../Common/AlertDialog';
import AccessTimeIcon from '@material-ui/icons/AccessTime';
import Autocomplete from '@material-ui/lab/Autocomplete';

const useStyles = makeStyles((theme) => ({
    root: {
        backgroundColor: theme.palette.background.dark,
        minHeight: '100%',
        paddingBottom: theme.spacing(3),
        paddingTop: theme.spacing(3)
    },
    avatar: {
        marginRight: theme.spacing(2)
    },
    colorApprove: {
        backgroundColor: "green",
    },
    textCenter: {
        textAlign: 'center',
    },
    fontColors: {
        color: 'grey'
    }

}));

function cardTitle(titleName) {
    return (
        <Grid container spacing={1}>
            <Grid item md={10} xs={12}>
                {titleName}
            </Grid>
        </Grid>
    )
}

const screenCode = 'BANKRECONCILIATIONAPPROVAL';
export default function BankReconcilationApproval(props) {

    const [title, setTitle] = useState("Approve Bank Reconciliation");
    const classes = useStyles();
    const navigate = useNavigate();
    const alert = useAlert();
    const [filter, setFilter] = useState({
        groupID: 0,
        factoryID: 0,
        bankLedgerAccountID: 0,
        toDate: ''
    });
    const [permissionList, setPermissions] = useState({
        isGroupFilterEnabled: false,
        isFactoryFilterEnabled: false
    });
    const [groups, setGroups] = useState();
    const [factories, setFactories] = useState();
    const [bankReconciliationData, setBankReconciliationData] = useState([]);
    const [endDateRange, setEndDateRange] = useState(new Date());
    const [selectedRows, setSelectedRows] = useState([]);
    const [IsSearchPerformed, setIsSearchPerformed] = useState(false);
    const [viewPopup, setViewPopup] = useState(false);
    const [banksAuto, setBanksAuto] = useState();
    const [isValid, setIsValid] = useState(true);
    const transactionModeLookup = {
        1: 'Main Cash',
        2: 'General Cash',
        3: 'Cheque',
        4: 'Income Invoice',
        5: 'Supplier Invoice',
        6: 'Provision',
        7: 'Transfer',
        998: 'Advance Payment Bank',
        999: 'Advance Payment Cheque'
    };
    const refreshPage = () => {
        window.location.reload();
    };


    const handleSelectAllClick = (event) => {
        const updatedBankReconciliationData = bankReconciliationData.map((row) => ({
            ...row,
            IsSelected: event.target.checked
        }));
        setBankReconciliationData(updatedBankReconciliationData);
        if (event.target.checked) {
            setSelectedRows(bankReconciliationData.map((row) => ({ ledgerTransactionID: row.ledgerTransactionID })));
        } else {
            setSelectedRows([]);
        }
    };

    const handleRowCheckboxClick = (event, ledgerTransactionID) => {
        const updatedBankReconciliationData = bankReconciliationData.map((row) => {
            if (row.ledgerTransactionID === ledgerTransactionID) {
                return {
                    ...row,
                    IsSelected: event.target.checked
                };
            }
            return row;
        });
        setBankReconciliationData(updatedBankReconciliationData);
        if (event.target.checked) {
            setSelectedRows((prevSelectedRows) => [
                ...prevSelectedRows,
                { ledgerTransactionID: ledgerTransactionID }
            ]);
        } else {
            setSelectedRows((prevSelectedRows) =>
                prevSelectedRows.filter((row) => row.ledgerTransactionID !== ledgerTransactionID)
            );
        }
    };

    useEffect(() => {
        setIsSearchPerformed(false);
    }, [filter.groupID, filter.factoryID, filter.bankLedgerAccountID, filter.toDate])

    useEffect(() => {
        trackPromise(getGroupsForDropdown(), getPermission());
    }, []);

    useEffect(() => {
        if (filter.groupID > 0) {
            trackPromise(getFactoriesForDropDown());
        }
    }, [filter.groupID]);

    useEffect(() => {
        if (filter.factoryID > 0) {
            getBankDetailsForDropdownAuto()
        }
    }, [filter.factoryID]);

    const handleApprovalConfirmation = (confirmed) => {
        if (confirmed) {
            trackPromise(SaveApprovedReconciliationData());
        }
    };

    async function getPermission() {
        var permissions = await authService.getPermissionsByScreen(screenCode);
        var isAuthorized = permissions.find(p => p.permissionCode == 'VIEWBANKRECONCILIATIONAPPROVAL');

        if (isAuthorized === undefined) {
            navigate('/404');
        }
        var isGroupFilterEnabled = permissions.find(p => p.permissionCode == 'GROUPDROPDOWN');
        var isFactoryFilterEnabled = permissions.find(p => p.permissionCode == 'FACTORYDROPDOWN');

        setPermissions({
            ...permissionList,
            isGroupFilterEnabled: isGroupFilterEnabled !== undefined,
            isFactoryFilterEnabled: isFactoryFilterEnabled !== undefined
        });

        setFilter({
            ...filter,
            groupID: parseInt(tokenService.getGroupIDFromToken()),
            factoryID: parseInt(tokenService.getFactoryIDFromToken())
        })
    }

    function generateDropDownMenu(data) {
        let items = []
        if (data != null) {
            for (const [key, value] of Object.entries(data)) {
                items.push(<MenuItem key={key} value={key}>{value}</MenuItem>);
            }
        }
        return items
    }

    async function getGroupsForDropdown() {
        const groups = await services.getAllGroups();
        setGroups(groups);
    }

    async function getFactoriesForDropDown() {
        const factory = await services.getFactoryByGroupID(filter.groupID);
        setFactories(factory);
    }

    async function getBankDetailsForDropdownAuto() {
        const banksResults = await services.getBankDetailsForDropdownAuto(filter.factoryID);
        setBanksAuto(banksResults);
    }

    function handleSearchDropdownChangeFieldsBankAccounts(data, e) {
        if (data === undefined || data === null) {
            setFilter({
                ...filter,
                bankLedgerAccountID: '0'
            });
            return;
        } else {
            var valueV = data["ledgerAccountID"];
            setFilter({
                ...filter,
                bankLedgerAccountID: valueV
            });
        }
    }

    function handleChange(e) {
        const target = e.target;
        const value = target.value
        setFilter({
            ...filter,
            [e.target.name]: value
        });
    }

    async function GetDetails() {
        let model = {
            groupID: parseInt(filter.groupID),
            factoryID: parseInt(filter.factoryID),
            BankLedgerAccountID: parseInt(filter.bankLedgerAccountID),
            toDate: endDateRange.toLocaleDateString()
        }
        const approveData = await services.GetBankReconciliationDataforApproval(model);

        if (approveData.statusCode === "Success" && approveData.data != null) {
            const updatedData = approveData.data.map((row) => ({
                ...row,
                IsSelected: true
            }));
            setBankReconciliationData(updatedData);
            setSelectedRows(updatedData.map((row) => ({ ledgerTransactionID: row.ledgerTransactionID })));
            setIsSearchPerformed(true);
        } else {
            setBankReconciliationData([]);
            alert.error(approveData.message);
        }
    }

    async function SaveApprovedReconciliationData() {

        const bankReconciliationDataToSend = bankReconciliationData.map(row => ({
            groupID: parseInt(filter.groupID),
            factoryID: parseInt(filter.factoryID),
            BankLedgerAccountID: parseInt(filter.bankLedgerAccountID),
            toDate: new Date(endDateRange).toISOString().split('T')[0],
            Date: new Date(row.date),
            ReferenceNumber: row.referenceNumber || "",
            Description: row.description || "",
            Credit: parseFloat(row.credit) || 0,
            Debit: parseFloat(row.debit) || 0,
            LedgerTransactionID: row.ledgerTransactionID,
            Payee: row.payee || "",
            TransactionModeName: row.transactionModeName || "",
            modifiedBy: tokenDecoder.getUserIDFromToken(),
            CreatedBy: tokenDecoder.getUserIDFromToken(),
            IsSelected: row.IsSelected || false,
            ReconsilationRevision: row.reconsilationRevision || 0
        }));

        let response = await services.ApproveBankReconciliationData(bankReconciliationDataToSend);

        if (response.statusCode === "Success") {
            setBankReconciliationData([]);
            setIsSearchPerformed(false);
            const selectedCount = selectedRows.length;
            alert.success(`${selectedCount} Reconciliation data approved successfully!`);
            refreshPage();
        } else {
            alert.error("Failed to Approve reconcilate data");
        }
        return response;
    }

    return (

        <Fragment>
            <LoadingComponent />
            <Page className={classes.root} title={title}>
                <Container maxWidth={false}>
                    <Formik
                        initialValues={{
                            groupID: filter.groupID,
                            factoryID: filter.factoryID,
                            bankLedgerAccountID: filter.bankLedgerAccountID,
                        }}
                        validationSchema={
                            Yup.object().shape({
                                groupID: Yup.number().required('Group is required').min('1', 'Group is required'),
                                factoryID: Yup.number().required('Factory is required').min('1', 'Factory is required'),
                                bankLedgerAccountID: Yup.number().required('Bank is required').min('1', 'Bank is Required'),
                            })
                        }
                        enableReinitialize
                        onSubmit={() => trackPromise(GetDetails())}
                    >
                        {({
                            errors,
                            handleBlur,
                            handleSubmit,
                            touched,

                        }) => (
                            <form onSubmit={handleSubmit}>
                                <Box mt={0}>
                                    <Card>
                                        <PerfectScrollbar>
                                            <CardHeader
                                                title={cardTitle(title)}
                                            />
                                            <Divider />
                                            <CardContent>
                                                <Grid container spacing={3}>
                                                    <Grid item md={4} xs={8}>
                                                        <InputLabel shrink id="groupID">
                                                            Group *
                                                        </InputLabel>
                                                        <TextField select
                                                            error={Boolean(touched.groupID && errors.groupID)}
                                                            fullWidth
                                                            helperText={touched.groupID && errors.groupID}
                                                            name="groupID"
                                                            onBlur={handleBlur}
                                                            onChange={(e) => handleChange(e)}
                                                            value={filter.groupID}
                                                            variant="outlined"
                                                            id="groupID"
                                                            disabled={!permissionList.isGroupFilterEnabled}
                                                            size='small'
                                                        >
                                                            <MenuItem value="0">--Select Group--</MenuItem>
                                                            {generateDropDownMenu(groups)}
                                                        </TextField>
                                                    </Grid>

                                                    <Grid item md={4} xs={8}>
                                                        <InputLabel shrink id="factoryID">
                                                            Factory *
                                                        </InputLabel>
                                                        <TextField select
                                                            error={Boolean(touched.factoryID && errors.factoryID)}
                                                            fullWidth
                                                            helperText={touched.factoryID && errors.factoryID}
                                                            name="factoryID"
                                                            onBlur={handleBlur}
                                                            onChange={(e) => handleChange(e)}
                                                            value={filter.factoryID}
                                                            variant="outlined"
                                                            id="factoryID"
                                                            disabled={!permissionList.isFactoryFilterEnabled}
                                                            size='small'
                                                        >
                                                            <MenuItem value="0">--Select Factory--</MenuItem>
                                                            {generateDropDownMenu(factories)}
                                                        </TextField>
                                                    </Grid>
                                                    <Grid item md={4} xs={8}>
                                                        <InputLabel shrink id="accountTypeID">
                                                            Bank Account *
                                                        </InputLabel>
                                                        <Autocomplete
                                                            id="accountTypeID"
                                                            options={banksAuto || []}
                                                            getOptionLabel={(option) => option?.ledgerAccountName
                                                                || "Unnamed Bank"}
                                                            onChange={(e, value) => handleSearchDropdownChangeFieldsBankAccounts(value, e)}
                                                            value={
                                                                banksAuto?.find(
                                                                    (option) => option.ledgerAccountID === filter.bankLedgerAccountID
                                                                ) || null
                                                            }
                                                            renderInput={(params) => (
                                                                <TextField
                                                                    {...params}
                                                                    variant="outlined"
                                                                    name="bankLedgerAccountID"
                                                                    fullWidth
                                                                    size="small"
                                                                    placeholder="--Select Account Type Name --"
                                                                    onBlur={handleBlur}
                                                                    error={Boolean(touched.bankLedgerAccountID && errors.bankLedgerAccountID)}
                                                                    helperText={touched.bankLedgerAccountID && errors.bankLedgerAccountID}
                                                                />
                                                            )}
                                                        />
                                                    </Grid>
                                                    <Grid item md={4} xs={12}>
                                                        <InputLabel shrink id="date"> Date *</InputLabel>

                                                        <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                                            <KeyboardDatePicker
                                                                fullWidth
                                                                variant="inline"
                                                                format="dd/MM/yyyy"
                                                                size='small'
                                                                inputVariant="outlined"
                                                                id="date-picker-inline"
                                                                value={endDateRange}
                                                                onChange={(e) => { setEndDateRange(e) }}
                                                                KeyboardButtonProps={{
                                                                    'aria-label': 'change date',
                                                                }}
                                                                InputProps={{
                                                                    readOnly: true,
                                                                }}
                                                                autoOk
                                                            />
                                                        </MuiPickersUtilsProvider>
                                                    </Grid>
                                                    <Grid container justify="flex-end">
                                                        <Box pr={2}>
                                                            <Button
                                                                color="primary"
                                                                variant="contained"
                                                                type="submit"
                                                                size='small'
                                                            >
                                                                Search
                                                            </Button>
                                                        </Box>
                                                    </Grid>

                                                </Grid>
                                                <br />
                                                {IsSearchPerformed === true && Array.isArray(bankReconciliationData) && bankReconciliationData.length > 0 ? (
                                                    <>
                                                        <br />
                                                        <Grid container spacing={2}>
                                                            <Grid item xs={3} style={{ marginLeft: '10px' }}>
                                                                <Typography color="textSecondary" gutterBottom>                                           <Chip
                                                                    style={{ marginLeft: '0', marginRight: '0', backgroundColor: "#FFFDD0", color: 'black', left: '0' }}
                                                                    icon={<AccessTimeIcon />}
                                                                    label={"No. Of Transactions: " + bankReconciliationData.length}
                                                                    clickable
                                                                    color="primary"
                                                                />
                                                                </Typography>
                                                            </Grid>
                                                            <Grid item xs={3} style={{ marginLeft: '-40px' }}>
                                                                <Typography color="textSecondary" gutterBottom>
                                                                    <Chip
                                                                        style={{ marginLeft: '0', marginRight: '0', backgroundColor: "#DFF2BF", color: 'black', left: '0' }}
                                                                        icon={<AccessTimeIcon />}
                                                                        label={"Selected Transaction Count: " + selectedRows.length}
                                                                        clickable
                                                                        color="primary"
                                                                    />
                                                                </Typography>
                                                            </Grid>

                                                            <Grid item xs={3}>
                                                                <Typography color="textSecondary" gutterBottom>
                                                                    <Chip
                                                                        style={{ marginLeft: '0', backgroundColor: "#FFD2D2", color: 'black' }}
                                                                        icon={<AccessTimeIcon />}
                                                                        label={"Un Selected Transaction Count: " + (bankReconciliationData.length - selectedRows.length)}
                                                                        clickable
                                                                        color="primary"
                                                                    />
                                                                </Typography>
                                                            </Grid>
                                                        </Grid>
                                                        <TableContainer style={{ maxHeight: '550px', overflowY: 'auto' }}>
                                                            <Table style={{ width: '100%' }} aria-label="bank reconciliation table">
                                                                <TableHead style={{ position: "sticky", top: 0, zIndex: 1000, background: "white" }}>
                                                                    <TableRow>
                                                                        <TableCell align="center" style={{ fontSize: "16px" }}><b>Reference Number</b></TableCell>
                                                                        <TableCell align="center" style={{ fontSize: "16px" }}><b>Date</b></TableCell>
                                                                        <TableCell align="center" style={{ fontSize: "16px" }}><b>Transaction Mode</b></TableCell>
                                                                        <TableCell align="center" style={{ fontSize: "16px" }}><b>CHQ/TRF No</b></TableCell>
                                                                        {/* <TableCell align="center" style={{ fontSize: "16px" }}><b>Payee/Customer</b></TableCell> */}
                                                                        <TableCell align="right" style={{ fontSize: "16px" }}><b>Debit</b></TableCell>
                                                                        <TableCell align="right" style={{ fontSize: "16px" }}><b>Credit</b></TableCell>
                                                                        <TableCell align="center" style={{ fontSize: "16px" }}>
                                                                            <b>Select All</b>
                                                                            <Checkbox
                                                                                indeterminate={selectedRows.length > 0 && selectedRows.length < bankReconciliationData.length}
                                                                                checked={selectedRows.length === bankReconciliationData.length}
                                                                                onChange={handleSelectAllClick}
                                                                            />
                                                                        </TableCell>
                                                                    </TableRow>
                                                                </TableHead>
                                                                <TableBody>
                                                                    {bankReconciliationData.map((row, index) => (
                                                                        <TableRow key={index}>
                                                                            <TableCell align="center">{row.referenceNumber}</TableCell>
                                                                            <TableCell align="center">{row.date ? row.date.split('T')[0] : ''}</TableCell>
                                                                            <TableCell align="center">{transactionModeLookup[row.modeoftransactionID ? row.modeoftransactionID : "-"]}</TableCell>
                                                                            <TableCell align="center">{row.chequeNumber ? row.chequeNumber : "-"}</TableCell>
                                                                            {/* <TableCell align="center">{row.payee ? row.payee : "-"}</TableCell> */}
                                                                            <TableCell align="right">{row.debit.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</TableCell>
                                                                            <TableCell align="right">{row.credit.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</TableCell>
                                                                            <TableCell align="center">
                                                                                <Checkbox
                                                                                    checked={selectedRows.some((selectedRow) => selectedRow.ledgerTransactionID === row.ledgerTransactionID)}
                                                                                    onChange={(event) => handleRowCheckboxClick(event, row.ledgerTransactionID)}
                                                                                />
                                                                            </TableCell>
                                                                        </TableRow>
                                                                    ))}
                                                                </TableBody>
                                                            </Table>
                                                        </TableContainer>
                                                    </>
                                                ) : (
                                                    <Typography align="center" variant="h6" style={{ margin: "1rem 0" }}>
                                                        No data available
                                                    </Typography>
                                                )}
                                            </CardContent>
                                        </PerfectScrollbar>
                                    </Card>
                                </Box>
                                <Card id="calculationDetails" style={{ marginTop: '1rem' }}>
                                    {
                                        IsSearchPerformed === true ? (
                                            <CardContent>
                                                <div>
                                                    <Box display="flex" justifyContent="flex-end" p={2}>
                                                        <Button
                                                            color="primary"
                                                            variant="contained"
                                                            size="small"
                                                            onClick={() => setViewPopup(true)}
                                                        >
                                                            Approve
                                                        </Button>
                                                    </Box>
                                                </div>
                                            </CardContent>
                                        ) : null
                                    }
                                    {viewPopup && (
                                        <AlertDialog
                                            confirmData={handleApprovalConfirmation}
                                            headerMessage="Confirm Approval"
                                            discription="Are you sure you want to approve this bank reconciliation?"
                                            isValid={isValid}
                                            viewPopup={viewPopup}
                                            setViewPopup={setViewPopup}
                                        />
                                    )}
                                </Card>
                            </form>
                        )}
                    </Formik>
                </Container>
            </Page>
        </Fragment>
    );
}